import { getCookie } from '@wildidea/components/utils/getCookie';

import { TrackingProviderId } from '@wildidea/onemap-cloud';

import { createPrincipalContext } from '@app/Principal/usePrincipal.js';

export interface Principal {
  id: TrackingProviderId;
  // email: string;
  // firstName: string;
  // lastName: string;
  // No roles - only features/policy
}

export type PrincipalState = Principal | null;

// https://aws.amazon.com/blogs/compute/simply-serverless-using-aws-lambda-to-expose-custom-cookies-with-api-gateway/
export const getPrincipal = (): Principal | null => {
  const idStr = getCookie('id');
  return idStr ? { id: TrackingProviderId.fromString(idStr) } : null;
};

export const { PrincipalProvider, usePrincipal, useUpdatePrincipal } =
  createPrincipalContext<Principal>(getPrincipal);

export const _setPrincipal = (
  principal: Principal | null,
  document: Document = window.document
) => {
  document.cookie = `id=${principal?.id || ''};Path=/;SameSite=Strict;${
    !principal ? 'max-age=-1;' : ''
  }`;
};
